// extracted by mini-css-extract-plugin
export default {"wrapper":"accordion_wrapper__m57bY","subHeader":"accordion_subHeader__TPkzK","line":"accordion_line__TK3d-","footer":"accordion_footer__iOOdD"};